import { LinearProgress as LinearProgressUI, WaitingButton } from "@evergis/ui";
import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const LoadingDescription = styled.div`
  color: ${({ theme: { palette } }) => palette.textSecondary};
  margin: 1.5rem 0 0.25rem;
`;

export const ConfirmText = styled.div`
  margin: 1rem 0 1.5rem;
`;

export const DeleteResourceButton = styled(WaitingButton)``;

export const LinearProgress = styled(LinearProgressUI)`
  margin-top: 0.875rem;
`;

export const DeleteDescription = styled.div`
  margin-top: 0;
`;

export const RequestLoader = styled.div`
  display: inline-flex;
  width: 5rem;
`;

export const CheckboxContainer = styled.div`
  margin-bottom: 1.5rem;
`;

export const AdditionalParametersToggler = styled.div`
  margin: 1.5rem 0;
`;
